var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6875 16.3281H3.3125C2.9668 16.3281 2.6875 16.6074 2.6875 16.9531V17.6562C2.6875 17.7422 2.75781 17.8125 2.84375 17.8125H18.1562C18.2422 17.8125 18.3125 17.7422 18.3125 17.6562V16.9531C18.3125 16.6074 18.0332 16.3281 17.6875 16.3281ZM5.5332 14.6875C5.57227 14.6875 5.61133 14.6836 5.65039 14.6777L8.93555 14.1016C8.97461 14.0938 9.01172 14.0762 9.03906 14.0469L17.3184 5.76758C17.3365 5.74951 17.3508 5.72805 17.3606 5.70442C17.3704 5.68079 17.3755 5.65546 17.3755 5.62988C17.3755 5.6043 17.3704 5.57897 17.3606 5.55535C17.3508 5.53172 17.3365 5.51026 17.3184 5.49219L14.0723 2.24414C14.0352 2.20703 13.9863 2.1875 13.9336 2.1875C13.8809 2.1875 13.832 2.20703 13.7949 2.24414L5.51562 10.5234C5.48633 10.5527 5.46875 10.5879 5.46094 10.627L4.88477 13.9121C4.86577 14.0167 4.87255 14.1244 4.90454 14.2258C4.93654 14.3273 4.99276 14.4193 5.06836 14.4941C5.19727 14.6191 5.35938 14.6875 5.5332 14.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b5cd49d952ea4c390adeb3a7df4133c4.svg";
export { ForwardRef as ReactComponent };